"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsTableFilterState = exports.eventsTableSingleFilter = exports.eventsTableStringObjectFilter = exports.eventsTableStringFilter = exports.singleFilter = exports.categoryOptionsFilter = exports.positionInTraceFilter = exports.nullFilter = exports.booleanFilter = exports.booleanObjectFilter = exports.numberObjectFilter = exports.stringObjectFilter = exports.arrayOptionsFilter = exports.stringOptionsFilter = exports.numberFilter = exports.stringFilter = exports.timeFilter = exports.FTS_MATCH_OPERATOR = exports.filterOperators = void 0;
const zod_1 = require("zod");
// Make sure to update the InMemoryFilterService if you add new filter types
exports.filterOperators = {
    datetime: [">", "<", ">=", "<="],
    string: ["=", "contains", "does not contain", "starts with", "ends with"],
    stringOptions: ["any of", "none of"],
    categoryOptions: ["any of", "none of"],
    arrayOptions: ["any of", "none of", "all of"],
    number: ["=", ">", "<", ">=", "<="],
    stringObject: [
        "=",
        "contains",
        "does not contain",
        "starts with",
        "ends with",
    ],
    numberObject: ["=", ">", "<", ">=", "<="],
    booleanObject: ["=", "<>"],
    boolean: ["=", "<>"],
    null: ["is null", "is not null"],
    positionInTrace: ["="],
};
exports.FTS_MATCH_OPERATOR = "matches";
exports.timeFilter = zod_1.z.object({
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.datetime),
    value: zod_1.z.coerce.date(), // coerce required to parse stringified dates from the db in evals
    type: zod_1.z.literal("datetime"),
});
exports.stringFilter = zod_1.z.object({
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.string),
    value: zod_1.z.string(),
    type: zod_1.z.literal("string"),
});
exports.numberFilter = zod_1.z.object({
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.number),
    value: zod_1.z.number(),
    type: zod_1.z.literal("number"),
});
exports.stringOptionsFilter = zod_1.z.object({
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.stringOptions),
    // do not filter on empty arrays, use refine to check this only at runtime (no type checking)
    value: zod_1.z.array(zod_1.z.string()).refine((v) => v.length > 0),
    type: zod_1.z.literal("stringOptions"),
});
exports.arrayOptionsFilter = zod_1.z
    .object({
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.arrayOptions),
    value: zod_1.z.array(zod_1.z.string()),
    type: zod_1.z.literal("arrayOptions"),
})
    .refine((data) => data.operator === "all of" ||
    data.operator === "none of" ||
    data.value.length > 0, {
    message: "Value array must not be empty unless operator is 'all of' or 'none of' (which represent waiting for selection)",
});
exports.stringObjectFilter = zod_1.z.object({
    type: zod_1.z.literal("stringObject"),
    column: zod_1.z.string(),
    key: zod_1.z.string(), // eg metadata --> "environment"
    operator: zod_1.z.enum(exports.filterOperators.string),
    value: zod_1.z.string(),
});
exports.numberObjectFilter = zod_1.z.object({
    type: zod_1.z.literal("numberObject"),
    column: zod_1.z.string(),
    key: zod_1.z.string(), // eg scores --> "accuracy"
    operator: zod_1.z.enum(exports.filterOperators.number),
    value: zod_1.z.number(),
});
exports.booleanObjectFilter = zod_1.z.object({
    type: zod_1.z.literal("booleanObject"),
    column: zod_1.z.string(),
    key: zod_1.z.string(), // eg scores --> "is_hallucination"
    operator: zod_1.z.enum(exports.filterOperators.booleanObject),
    value: zod_1.z.boolean(),
});
exports.booleanFilter = zod_1.z.object({
    type: zod_1.z.literal("boolean"),
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.boolean),
    value: zod_1.z.boolean(),
});
exports.nullFilter = zod_1.z.object({
    type: zod_1.z.literal("null"),
    column: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.null),
    value: zod_1.z.literal(""),
});
exports.positionInTraceFilter = zod_1.z
    .object({
    type: zod_1.z.literal("positionInTrace"),
    column: zod_1.z.string(),
    operator: zod_1.z.literal("="),
    key: zod_1.z.enum(["root", "first", "last", "nthFromEnd", "nthFromStart"]),
    value: zod_1.z.number().optional(),
})
    .superRefine((data, ctx) => {
    const needsValue = data.key === "nthFromEnd" || data.key === "nthFromStart";
    if (needsValue && (!data.value || data.value < 1)) {
        ctx.addIssue({
            code: "custom",
            message: "Position must be >= 1 for nth selection",
            path: ["value"],
        });
    }
});
exports.categoryOptionsFilter = zod_1.z.object({
    type: zod_1.z.literal("categoryOptions"),
    column: zod_1.z.string(),
    key: zod_1.z.string(),
    operator: zod_1.z.enum(exports.filterOperators.categoryOptions),
    value: zod_1.z.array(zod_1.z.string()),
});
exports.singleFilter = zod_1.z.discriminatedUnion("type", [
    exports.timeFilter,
    exports.stringFilter,
    exports.numberFilter,
    exports.stringOptionsFilter,
    exports.categoryOptionsFilter,
    exports.arrayOptionsFilter,
    exports.stringObjectFilter,
    exports.numberObjectFilter,
    exports.booleanObjectFilter,
    exports.booleanFilter,
    exports.nullFilter,
    exports.positionInTraceFilter,
]);
const eventsTableStringOperator = zod_1.z.union([
    zod_1.z.enum(exports.filterOperators.string),
    zod_1.z.literal(exports.FTS_MATCH_OPERATOR),
]);
const eventsTableStringObjectOperator = zod_1.z.union([
    zod_1.z.enum(exports.filterOperators.stringObject),
    zod_1.z.literal(exports.FTS_MATCH_OPERATOR),
]);
exports.eventsTableStringFilter = exports.stringFilter.extend({
    operator: eventsTableStringOperator,
});
exports.eventsTableStringObjectFilter = exports.stringObjectFilter.extend({
    operator: eventsTableStringObjectOperator,
});
exports.eventsTableSingleFilter = zod_1.z.discriminatedUnion("type", [
    exports.timeFilter,
    exports.eventsTableStringFilter,
    exports.numberFilter,
    exports.stringOptionsFilter,
    exports.categoryOptionsFilter,
    exports.arrayOptionsFilter,
    exports.eventsTableStringObjectFilter,
    exports.numberObjectFilter,
    exports.booleanObjectFilter,
    exports.booleanFilter,
    exports.nullFilter,
    exports.positionInTraceFilter,
]);
exports.eventsTableFilterState = zod_1.z.array(exports.eventsTableSingleFilter);
